module.exports = __webpack_public_path__ + "static/media/star.26a1b0aa.svg";